import { namespace, OfcsObject } from '../../ofcs';
import Modal from './modal';

/**
 * ModalFactory prototype
 *
 *     var modalFactory = new ModalFactory({
 *          "some.key": {
 *              header: "This is some header template <%= var %>",
 *              body: "This is some body template <%= var %>",
 *              buttons: [
 *                  {label: "Button1", dismiss: true, type: "primary", event: "confirm"},
 *                  {label: "Button2", dismiss: false, type: "danger", icon: "trash"}
 *              ]
 *          }
 *     });
 *
 *     var modal = modalFactory.createModal("some.key");
 *
 * @class   ModalFactory
 *
 * @cfg {Object} options
 * An object that defines several presets of modal configurations with a unique
 * key to access this configuration object.
 */
class ModalFactory extends OfcsObject {
    defaultOptions = {
        loaderTemplate: '',
    };

    /**
     * @param {Object} modalConfigurations
     * @param {Object} defaultOptions
     */
    constructor(modalConfigurations, defaultOptions = {}) {
        super();
        this.modalConfigurations = { ...modalConfigurations };
        this.defaultOptions = { ...this.defaultOptions, ...defaultOptions };
    }

    /**
     * Create a new modal object based on a configuration preset.
     *
     * @param {string} key The key of a modal configuration object defined in the constructor
     * @param {Object} [options] Overwrite the default options
     * @return {Modal}
     */
    createModal(key, options) {
        if (!this.modalConfigurations[key]) {
            throw new Error(`Couldn't find key '${key}' to create a new modal.`);
        }

        return new Modal({
            ...this.defaultOptions,
            ...this.modalConfigurations[key] ?? {},
            ...options ?? {},
        });
    }
}

namespace('Ofcs.Modal');
Ofcs.Modal.ModalFactory = ModalFactory;
export default ModalFactory;
